export const componentList = [
  'ChangePassword',
  'SanctionFilter',
  'NewsFilter',
  'LangSelector',
  'SanctionFilterNew',
  'NetvisorCalendar',
  'ConnectionCheck'
]
